import { useAppSelector } from '../../../../hooks/useAppStore';
import { getSelectedFilterItems } from '../../../../store/common/selectors';
import { TAssignOrder, TOrder } from '../../../../types';

export function useOrdersFilter() {
  const selectedFilterItems = useAppSelector(getSelectedFilterItems);

  const getOrdersByLocations = (orders: Array<TAssignOrder> | Array<TOrder>) => {
    const locationIds = selectedFilterItems.location.map((location) => Number(location.value));

    return orders.filter((order) => locationIds.includes(Number(order.locationId)));
  };

  const getOrdersByChannel = (orders: Array<TAssignOrder> | Array<TOrder>) => {
    const channelItems = selectedFilterItems.channel.map((location) => location.value);

    return orders.filter((order) => channelItems.includes(order.sourceName));
  };

  const getOrdersByAttributed = (orders: Array<TAssignOrder> | Array<TOrder>) => {
    const attributedItems = selectedFilterItems.attributed.map((attribute) => attribute.value);

    return orders.filter((order) => {
      const orderEmail = order.member?.email;
      const orderUserId = String(order.userId);

      // Check if attributedItems includes either the order's email or userId
      return attributedItems.includes(orderEmail) || attributedItems.includes(orderUserId);
    });
  };

  return {
    getOrdersByLocations,
    getOrdersByChannel,
    getOrdersByAttributed,
  };
}
